import { createSlice } from '@reduxjs/toolkit'
import { login, register, logout, updatePassword } from '../actions/authActions.js'

const initialState = {
  isAuthenticated: false,
  loading: false,
  error: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetAuthState: state => {
      state.isAuthenticated = false
      state.loading = false
      state.error = null
    },
  },
  extraReducers: builder => {
    builder
      .addCase(login.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isAuthenticated = true
        state.loading = false
        state.user = action.payload.admin
        state.token = action.payload.token
        localStorage.setItem('authToken', action.payload.token)
        localStorage.setItem('user', JSON.stringify(action.payload.admin))
      })
      .addCase(login.rejected, (state, action) => {
        state.error = action.error.message
        state.loading = false
      })
      .addCase(register.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(register.fulfilled, state => {
        state.isAuthenticated = true
        state.loading = false
      })
      .addCase(register.rejected, (state, action) => {
        state.error = action.error.message
        state.loading = false
      })
      .addCase(logout.fulfilled, state => {
        state.isAuthenticated = false
        state.loading = false
      })
      .addCase(updatePassword.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(updatePassword.fulfilled, state => {
        state.loading = false
      })
      .addCase(updatePassword.rejected, (state, action) => {
        state.error = action.error.message
        state.loading = false
      })
  },
})

export const { resetAuthState } = authSlice.actions

export default authSlice.reducer
